import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid } from "@mui/material";
import { AlertSpg, GridSpg, TableSkeleton } from "@duosoftbg/nacid-components";
import RSearchAcademicRecognitionUniversitiesListTable from "./RSearchAcademicRecognitionUniversitiesListTable";

const RSearchAcademicRecognitionUniversitiesList = ({
  records,
  total,
  isLoading,
  onPageOrOrderChange,
  blockTable,
  group,
  viewURL,
}) => {
  const { t } = useTranslation();

  const showTable = () => {
    if (!(total > 0)) {
      return (
        <AlertSpg mt={10} severity="info">
          {t("m.empty.list")}
        </AlertSpg>
      );
    }
    return (
      <RSearchAcademicRecognitionUniversitiesListTable
        records={records}
        total={total}
        onPageOrOrderChange={onPageOrOrderChange}
        blockTable={blockTable}
        group={group}
        viewURL={viewURL}
      />
    );
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <GridSpg item xs={12}>
          {isLoading ? <TableSkeleton /> : showTable()}
        </GridSpg>
      </Grid>
    </Box>
  );
};

export default RSearchAcademicRecognitionUniversitiesList;
